// @flow

import { makeApiCall } from '../../../../services/apiService/apiService';

export const clientCommunicationActions = {
  GET_USER_CLIENTS: 'GET_USER_CLIENTS',
  GET_DEFAULT_USER_SETTINGS: 'GET_DEFAULT_USER_SETTINGS',
  FILTER_CLIENT_LIST: 'FILTER_CLIENT_LIST',
  GET_USER_OPTIONS_LIST: 'GET_USER_OPTIONS_LIST',
  EDIT_USER: 'EDIT_USER',
  ADD_USER: 'ADD_USER'
};

export const filterClientList = (searchString: string) => ({
  type: clientCommunicationActions.FILTER_CLIENT_LIST,
  payload: searchString
});

export const getUserOptionListAction = (load: Object) => ({
  type: clientCommunicationActions.GET_USER_OPTIONS_LIST,
  payload: load
});

export const getUserOptionList = (obj: Object) => (dispatch: Function) => {
  // dispatch(getUserClientsAction())
  const requestObj = {
    baseUrl: 'zoomCommunicationsEp',
    apiEndPoint: 'ccGetClientUserList',
    pathVariables: [
      { key: 'name', val: obj.name },
      { key: 'clientId', val: obj.clientId }
    ],
    replaceParamsArr: [{ key: 'userType', val: obj.userType }],
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('getUserOptionList call returns 200 ', res);
      dispatch(
        getUserOptionListAction({
          userOptionsList: res.payload,
          errorMessage: null
        })
      );
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('getUserOptionList call failed ', res);
      dispatch(
        getUserOptionListAction({
          userOptionsList: [],
          errorMessage: res.errorMessage || 'Could not get user list'
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in getUserOptionList call', res);
      dispatch(
        getUserOptionListAction({
          userOptionsList: [],
          errorMessage: (res && res.errorMessage) || 'Could not get user list'
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getUserClientsAction = (load: Object) => ({
  type: clientCommunicationActions.GET_USER_CLIENTS,
  payload: load
});

export const getUserClients = (userProfile: Object) => (dispatch: Function) => {
  dispatch(
    getUserClientsAction({
      fetchingInitialPageDetails: true,
      fetchedInitialPageDetails: false,
      ccPageData: null,
      ccPageDataClientWiseFiltered: null,
      errorMessage: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomCommunicationsEp',
    apiEndPoint: 'ccGetUserClients',
    replaceParamsArr: [
      { key: 'email', val: userProfile.email },
      { key: 'mobileNumber', val: userProfile.mobile }
    ],
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('getUserClients call returns 200 ', res);
      dispatch(
        getUserClientsAction({
          fetchingInitialPageDetails: false,
          fetchedInitialPageDetails: true,
          ccPageData: res.payload,
          ccPageDataClientWiseFiltered: res.payload,
          errorMessage:
            res.status === 'SUCCESS' && res.payload && res.payload.length
              ? null
              : res.errorMessage || 'No data found'
        })
      );
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('getUserClients call failed ', res);
      dispatch(
        getUserClientsAction({
          fetchingInitialPageDetails: false,
          fetchedInitialPageDetails: true,
          ccPageData: [],
          ccPageDataClientWiseFiltered: [],
          errorMessage: res.errorMessage || 'Could not get client users'
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in getUserClients call', res);
      dispatch(
        getUserClientsAction({
          fetchingInitialPageDetails: false,
          fetchedInitialPageDetails: true,
          ccPageData: [],
          ccPageDataClientWiseFiltered: [],
          errorMessage: res.errorMessage || 'Could not get client users'
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getDefaultUserSettingsAction = (data: Object) => ({
  type: clientCommunicationActions.GET_DEFAULT_USER_SETTINGS,
  payload: data
});

export const getDefaultUserSettings = (loggedInUserType: string) => (
  dispatch: Function
) => {
  dispatch(
    getDefaultUserSettingsAction({
      defaultUserSettings: {
        isLoading: true,
        isLoaded: false,
        data: {}
      },
      errorMessage: null,
      postCallProgress: null,
      postCallCompleted: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomCommunicationsEp',
    apiEndPoint: 'ccGetDefaultUserSettings',
    replaceParamsArr: [{ key: 'userType', val: loggedInUserType }],
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('getRealTimeSettings call ', res);

      dispatch(
        getDefaultUserSettingsAction({
          defaultUserSettings: {
            isLoading: false,
            isLoaded: true,
            data: res.payload
          },
          errorMessage: null,
          postCallProgress: null,
          postCallCompleted: null
        })
      );
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('getRealTimeSettings call failed ', res);
      getDefaultUserSettingsAction({
        defaultUserSettings: {
          isLoading: false,
          isLoaded: true,
          data: []
        },
        errorMessage: res.errorMessage || 'Could not get default user settings',
        postCallProgress: null,
        postCallCompleted: null
      });
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in getRealTimeSettings call', res);
      dispatch(
        getDefaultUserSettingsAction({
          defaultUserSettings: {
            isLoading: false,
            isLoaded: true,
            data: []
          },
          errorMessage:
            res.errorMessage || 'Could not get default user settings',
          postCallProgress: null,
          postCallCompleted: null
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const editUserAction = (load: Object) => ({
  type: clientCommunicationActions.EDIT_USER,
  payload: load
});

export const editUser = userData => dispatch => {
  dispatch(
    editUserAction({
      postCallProgress: true,
      postCallCompleted: false,
      message: null,
      errorMessage: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomCommunicationsEp',
    apiEndPoint: 'ccEditNotificationsUser',
    pathVariables: [{ key: 'id', val: userData.userId }],
    method: 'PUT',
    data: userData,
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('editUser call ', res);

      if (res.status === 'SUCCESS') {
        dispatch(
          editUserAction({
            postCallCompleted: true,
            postCallProgress: false,
            message: res.payload || 'Succesfully updated user data',
            errorMessage: null
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          editUserAction({
            postCallCompleted: true,
            postCallProgress: false,
            message: null,
            errorMessage: res.errorMessage
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('editUser call failed ', res);
      dispatch(
        editUserAction({
          postCallCompleted: true,
          postCallProgress: false,
          message: null,
          errorMessage: res.errorMessage || 'Could not edit user data'
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in editUser call', res);
      dispatch(
        editUserAction({
          postCallCompleted: true,
          postCallProgress: false,
          message: null,
          errorMessage: res.errorMessage || 'Could not edit user data'
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const addUserAction = (load: Object) => ({
  type: clientCommunicationActions.ADD_USER,
  payload: load
});

export const addUser = userData => dispatch => {
  dispatch(
    addUserAction({
      postCallProgress: true,
      postCallCompleted: false,
      message: null,
      errorMessage: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomCommunicationsEp',
    apiEndPoint: 'ccAddNotificationsUser',
    method: 'POST',
    data: userData,
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('addUser call ', res);

      if (res.status === 'SUCCESS') {
        dispatch(
          editUserAction({
            postCallCompleted: true,
            postCallProgress: false,
            message: res.payload || 'Succesfully added user data',
            errorMessage: null
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          editUserAction({
            postCallCompleted: true,
            postCallProgress: false,
            message: null,
            errorMessage: res.errorMessage
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('addUser call failed ', res);
      dispatch(
        editUserAction({
          postCallCompleted: true,
          postCallProgress: false,
          message: null,
          errorMessage: res.errorMessage || 'Could not add user data'
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in addUser call', res);
      dispatch(
        editUserAction({
          postCallCompleted: true,
          postCallProgress: false,
          message: null,
          errorMessage: res.errorMessage || 'Could not add user data'
        })
      );
    }
  };

  return makeApiCall(requestObj);
};
